import { BundleBasketData } from '@src/types/bundle';

const getSelectedQuoteUnwrapped =
  (basket: Nullable<BundleBasketData>) => (tariffId: string) =>
    basket?.broadband.quotes.find((quote) => quote.id === tariffId);

export { getSelectedQuoteUnwrapped };
